module.exports = __webpack_public_path__ + "static/media/i-am-i-who-are-you.ac0cfd65.txt";